export const notificationType = {
  commentMentioned: "comment_user_mention",
  researchCompleted: "research_completed",
  exportCompleted: "export_completed",
  enrichmentCompleted: "enrichment_completed",
  emailClicked: "email_clicked",
  emailOpened: "email_opened",
  taskAssigned: "task_assigned",
  taskReminder: "task_reminder",
  taskAssigneeUpdate: "task_assignee_update",
  linkedinInviteAccepted: "linkedin_invite_accepted",
  leadOwnerUpdate: "lead_owner_update",
  dealStatusUpdate: "deal_status_update",
  dealOwnerUpdate: "deal_owner_update",
  meetingBooked: "meeting_booked",
  contactOwnerUpdate: "contact_owner_update",
};
